var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 8.16681H10.8333V9.83348H4.16667V12.3335L0 9.00014L4.16667 5.66681V8.16681ZM3.33273 14.0001H5.59029C6.76552 15.0374 8.30926 15.6668 10 15.6668C13.6819 15.6668 16.6667 12.6821 16.6667 9.00014C16.6667 5.31824 13.6819 2.33348 10 2.33348C8.30926 2.33348 6.76552 2.96287 5.59029 4.00014H3.33273C4.85307 1.97607 7.27363 0.666809 10 0.666809C14.6023 0.666809 18.3333 4.39777 18.3333 9.00014C18.3333 13.6025 14.6023 17.3335 10 17.3335C7.27363 17.3335 4.85307 16.0242 3.33273 14.0001Z",
    fill: "#FF4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoog);
export default __webpack_public_path__ + "static/media/loog.9c9fd2be60adac06b0f1aa7185f47778.svg";
export { ForwardRef as ReactComponent };